import PropTypes from 'prop-types'
import React, { useEffect, useRef, useCallback } from 'react'
import { Icon } from '@ailibs/feather-react-ts'
import SimpleBar from 'simplebar-react'
import MetisMenu from 'metismenujs'
import { Link } from 'react-router-dom'

export const SidebarContent = (props: any) => {
  const ref = useRef<any>()

  const activateParentDropdown = useCallback(
    (item: {
      classList: { add: (arg0: string) => void }
      parentElement: any
    }) => {
      item.classList.add('active')
      const parent = item.parentElement
      const parent2El = parent.childNodes[1]
      if (parent2El && parent2El.id !== 'side-menu') {
        parent2El.classList.add('mm-show')
      }

      if (parent) {
        parent.classList.add('mm-active')
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.add('mm-show') // ul tag

          const parent3 = parent2.parentElement // li tag

          if (parent3) {
            parent3.classList.add('mm-active') // li
            parent3.childNodes[0].classList.add('mm-active') // a
            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.add('mm-show') // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.add('mm-show') // li
                parent5.childNodes[0].classList.add('mm-active') // a tag
              }
            }
          }
        }
        scrollElement(item)
        return false
      }
      scrollElement(item)
      return false
    },
    [],
  )

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu('#side-menu')
      let matchingMenuItem = null
      const ul: any = document.getElementById('side-menu')
      const items = ul.getElementsByTagName('a')
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }
  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: '100%' }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">Menu</li>
            <li>
              <Link to="/">
                <Icon name="home" />
                <span>Home</span>
              </Link>
            </li>
            <li className="menu-title">Resources</li>
            <li>
              <Link to="/posts">
                <Icon name="file-text" />
                <span>Posts</span>
              </Link>
            </li>
            <li>
              <Link to="/courses">
                <Icon name="book-open" />
                <span>Courses</span>
              </Link>
            </li>
            <li>
              <Link to="/lessons">
                <Icon name="file" />
                <span>Lessons</span>
              </Link>
            </li>
            <li>
              <Link to="/flash-cards">
                <Icon name="credit-card" />
                <span>Flash Cards</span>
              </Link>
            </li>
            <li className="menu-title">Images</li>
            <li>
              <Link to="/post-images">
                <Icon name="image" />
                <span>Post</span>
              </Link>
            </li>
            <li>
              <Link to="/flash-card-images">
                <Icon name="image" />
                <span>Flashcard</span>
              </Link>
            </li>
            <li>
              <Link to="/course-images">
                <Icon name="image" />
                <span>Course</span>
              </Link>
            </li>
            <li>
              <Link to="/content-images">
                <Icon name="image" />
                <span>Content</span>
              </Link>
            </li>
            <li>
              <Link to="/static-images">
                <Icon name="image" />
                <span>Static</span>
              </Link>
            </li>
            <li className="menu-title">Discoverability</li>
            <li>
              <Link to="/tags">
                <Icon name="tag" />
                <span>Tags</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}
